import InteractionLayer from "./InteractionLayer";
import { observe } from "lib/reactive";
export class ValueInteraction extends InteractionLayer {
    constructor(config = {}) {
        super();
        this.config = config;
        this._preview = null;
        this.value = observe({ value: null, committed: false });
        this.setPreviewFunction(config.preview_render);
        if (config.preview_render) {
            this.onPreview(value => {
                if (this._preview)
                    this._preview.remove();
                if (value != null)
                    this._preview = this.previewFunction?.(value)?.addTo(this);
            });
        }
    }
    setPreviewFunction(f) {
        this.previewFunction = f;
        this.preview(this.value.value().value);
        return this;
    }
    cancel() {
        if (!this.value.value().committed)
            this.value.set({ value: null, committed: true });
        super.cancel();
    }
    commit(value) {
        this.value.set({ value: value, committed: true });
        this.cancel();
    }
    preview(value) {
        this.value.set({ value: value, committed: false });
        return this;
    }
    onChange(handler) {
        this.value.subscribe(handler);
        return this;
    }
    onPreview(handler) {
        this.value.subscribe((v) => { if (!v.committed)
            handler(v.value); });
        return this;
    }
    onCommit(handler) {
        this.value.subscribe((v) => { if (v.committed && v.value)
            handler(v.value); });
        return this;
    }
    onDiscarded(handler) {
        this.value.subscribe((v) => { if (v.committed && !v.value)
            handler(); });
        return this;
    }
}
